import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from "@angular/material/dialog";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { User } from "@teammood/shared/util/user";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ContactUsService } from "./contact-us.service";
import { Subject, takeUntil, tap } from "rxjs";
import { SnackBarService } from "@teammood/shared/ui/snack-bar";

@Component({
    selector: 'tm-contact-us-dialog',
    templateUrl: 'contact-us-dialog.component.html',
    styleUrls: ['contact-us-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        TranslateModule,
        MatDialogContent,
        MatDialogActions,
        ReactiveFormsModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [ContactUsService]
})
export class TmContactUsDialogComponent implements OnInit, OnDestroy {

    protected dialogData: ContactUsDialogData;

    protected messageCtrl: FormControl<string | null> = new FormControl<string>('', [Validators.required, Validators.minLength(10)]);
    protected messageFormGroup: FormGroup = new FormGroup({
        messageCtrl: this.messageCtrl,
    });

    private _destroy$ = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA) protected data: ContactUsDialogData,
        private dialogRef: MatDialogRef<TmContactUsDialogComponent>,
        private contactUsService: ContactUsService,
        private snackBarService: SnackBarService,
        private translate: TranslateService,
    ) {}

    ngOnInit() {
        this.dialogData = this.data;
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    protected onClose() {
        this.dialogRef.close();
    }

    protected sendMessage(){
        const message = this.messageCtrl.value;
        this.contactUsService.send(message).pipe(
            tap(() => {
                this.snackBarService.success(this.translate.instant('contact_us.modal.success'));
                this.dialogRef.close();
            }),
            takeUntil(this._destroy$)
        ).subscribe();

    }
}

interface ContactUsDialogData {
    user: User;
}